import { useState } from 'react'
import { Link, useLocation } from 'react-router-dom'
import { useTranslation } from 'react-i18next'
import { MenuOutlined } from '@ant-design/icons'
import { Drawer } from 'antd'
import LogoMark from './LogoMark'
import BrandText from './BrandText'
import styles from './Header.module.css'

export default function Header() {
  const { t, i18n } = useTranslation('common')
  const location = useLocation()
  const [mobileOpen, setMobileOpen] = useState(false)

  const toggleLang = () => {
    i18n.changeLanguage(i18n.language === 'zh' ? 'en' : 'zh')
  }

  const isActive = (path: string) => {
    if (path === '/') return location.pathname === '/'
    return location.pathname.startsWith(path)
  }

  const navItems = [
    { path: '/', label: t('nav.home') },
    { path: '/gallery', label: t('nav.gallery') },
    { path: '/about', label: t('nav.about') },
    { path: '/contact', label: t('nav.contact') },
  ]

  return (
    <>
      <header className={`${styles.header} ${styles.scrolled}`} role="banner">
        <div className={styles.inner}>
          <Link to="/" className={styles.logo} aria-label={t('a11y.homeLink')}>
            <LogoMark />
            <BrandText className={styles.logoText} />
          </Link>

          <nav className={styles.desktopNav} aria-label={t('a11y.primaryNav')}>
            {navItems.map((item) => (
              <Link
                key={item.path}
                to={item.path}
                className={`${styles.navLink} ${isActive(item.path) ? styles.active : ''}`}
              >
                {item.label}
              </Link>
            ))}
          </nav>

          <div className={styles.actions}>
            <button
              className={styles.langBtn}
              onClick={toggleLang}
              aria-label={`Switch to ${i18n.language === 'zh' ? 'English' : '中文'}`}
            >
              {i18n.language === 'zh' ? 'EN' : '中'}
            </button>

            <button
              className={styles.hamburger}
              onClick={() => setMobileOpen(true)}
              aria-label={t('a11y.openMenu')}
            >
              <MenuOutlined />
            </button>
          </div>
        </div>
      </header>

      <Drawer
        placement="right"
        onClose={() => setMobileOpen(false)}
        open={mobileOpen}
        width={280}
        title={
          <div className={styles.drawerTitle}>
            <LogoMark />
            <BrandText />
          </div>
        }
      >
        <nav className={styles.mobileNav} aria-label={t('a11y.mobileNav')}>
          {navItems.map((item) => (
            <Link
              key={item.path}
              to={item.path}
              className={`${styles.mobileNavLink} ${isActive(item.path) ? styles.mobileActive : ''}`}
              onClick={() => setMobileOpen(false)}
            >
              {item.label}
            </Link>
          ))}
          <div className={styles.mobileLang}>
            <button className={styles.langBtn} onClick={toggleLang}>
              {i18n.language === 'zh' ? 'Switch to English' : '切换到中文'}
            </button>
          </div>
        </nav>
      </Drawer>
    </>
  )
}
